module.exports = __webpack_public_path__ + "static/media/session-detail-clock.96d87534.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/session-detail-clock.svg
// module id = 836
// module chunks = 1